import Icon from '@mdi/react';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import EmojiText from '../EmojiText/EmojiText';

import styles from './BlockViewerContainer.module.sass';

export const UserMessageBlockViewerContainer = ({
    label,
    labelId,
    icon,
    iconSize = 1,
    isCollapsed,
    isAnimated,
    className,
    labelClassName,
    children,
}: {
    label: string;
    labelId?: string;
    icon: string | ReactNode;
    iconSize?: number;
    isCollapsed: boolean;
    isAnimated?: boolean;
    className?: string;
    labelClassName?: string;
    children: ReactNode;
}) => {
    return (
        <section
            aria-label={label}
            className={twMerge(
                'ms-auto p-2 rounded-xl rounded-tr-md origin-top-right',
                isCollapsed
                    ? 'p-0'
                    : 'p-2 bg-gradient-to-bl from-slate-100 to-transparent',
                isAnimated
                    ? styles['usermessageblockviewercontainer--animated']
                    : '',
                className,
            )}
        >
            <div
                className={twMerge(
                    'flex gap-1.5 items-center justify-end ml-auto px-2 pb-2 motion-safe:transition-all text-primary-text-base-aa',
                    isCollapsed ? 'opacity-0 -mb-8' : '',
                    labelClassName,
                )}
            >
                {typeof icon === 'string' ? (
                    <Icon path={icon} size={iconSize} />
                ) : (
                    icon
                )}
                <p id={labelId} className="text-right font-bold">
                    <EmojiText>{label}</EmojiText>
                </p>
            </div>
            <div>{children}</div>
        </section>
    );
};
